import React, { Component } from 'react';
import { Dimensions, View } from 'react-native';
import { dialog } from '../../../css/dialog';
import { modal } from '../../../css/modal';
import Button from '../core/Button';
import Text from '../core/Text';
import GlobalConstants from '../GlobalConstants';
import GlobalVariables from '../GlobalVariables';
import t from '../../../translation';
import { styles } from '../../../css/container';
import { BaseDlgProps } from '../props/BaseDlgProps';

class CYESNOChips extends Component<BaseDlgProps> {
    start: number;
    title: string;
    info: string;
    chips: number;
    yes: boolean;
    constructor(props: BaseDlgProps) {
        super(props);
    }

    SetTitleAndChips(title: string, info: string, chips: number) {
        this.title = t.t(title);
        this.info = t.t(info);
        this.chips = chips;
    }

    performTimeConsumingTask = async () => {
        return new Promise((resolve) =>
            setTimeout(() => {
                resolve(GlobalConstants.IDOK);
            }, 100)
        );
    };

    componentDidMount() {
        this.props.onRef(this);
    }
    OnOk() {
        this.props.m_pwin.state.CYESNOChipsVisible = false;
        this.yes = true;
        this.start = 0;
        this.props.m_pwin.setState({});
    }
    OnCancel() {
        this.props.m_pwin.state.CYESNOChipsVisible = false;
        this.yes = false;
        this.start = 0;
        this.props.m_pwin.setState({});
    }

    async DoModal() {
        this.props.m_pwin.state.CYESNOChipsVisible = true;
        this.props.m_pwin.setState({});
        this.start = 1;
        while (this.start === 1 && this.props.m_pwin.state.CYESNOChipsVisible) {
            await this.performTimeConsumingTask();
        }
        if (this.yes === true) {
            return GlobalConstants.IDOK;
        } else {
            return GlobalConstants.IDNO;
        }
    }

    render() {
        if (this.props.m_pwin.state.CYESNOChipsVisible) {
            return (
                <View style={[styles.modal, { width: Dimensions.get('window').width, height: Dimensions.get('window').height }]}>
                    <View
                        style={[
                            dialog.dialogView,
                            {
                                top: GlobalVariables.WindowHeight / 5,
                                left: GlobalVariables.positionLeft + 20 * GlobalVariables.scale,
                                width: 750 * GlobalVariables.scale,
                            },
                        ]}
                    >
                        <View style={styles.doalogTitle}>
                            <Text textSize={GlobalConstants.LARGE_FONT_SIZE}>{this.title}</Text>
                        </View>
                        <View style={[styles.row, styles.padding1]}>
                            <Text textSize={GlobalConstants.LARGE_FONT_SIZE}>{this.info}</Text>
                        </View>
                        <View style={styles.row}>
                            <Text textSize={GlobalConstants.LARGE_FONT_SIZE}>{this.chips ? this.chips.toString() + ' ' : ' '}</Text>
                            <Text textSize={GlobalConstants.LARGE_FONT_SIZE}>
                                {this.props.m_pwin.m_main.GetLanguageText('Chips') +
                                    ' ' +
                                    this.props.m_pwin.m_main.GetLanguageText('will be deducted from your account.')}
                            </Text>
                        </View>
                        <View style={styles.row}>
                            <Button
                                textSize={GlobalConstants.SUPER_EXTRA_LARGE_FONT_SIZE}
                                containerStyle={modal.buttonStyle3PerRow}
                                onPress={this.OnOk.bind(this)}
                                text="Yes"
                            />
                            <Button
                                textSize={GlobalConstants.SUPER_EXTRA_LARGE_FONT_SIZE}
                                containerStyle={modal.buttonStyle3PerRow}
                                onPress={this.OnCancel.bind(this)}
                                text="No"
                            />
                        </View>
                    </View>
                </View>
            );
        } else {
            return null;
        }
    }
}

export default CYESNOChips;
